import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { PageHeader } from "../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../shared/components/pageHeader/PageHeaderApi"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { QueryErrorBoundary } from "../../../core/api/components/QueryErrorBoundary"
import { Suspense } from "react"
import { LoadingSpinner } from "../../../shared/components/loading/LoadingSpinner"
import { UserProfileContent } from "../components/UserProfileContent"
import { StandardTabs } from "../../../shared/components/tabs/StandardTabs"
import { useAppLocalization } from "../../localization/components/AppLocalizationProvider"
import { GdprDownloadTab } from "../../profile/components/GdprDownloadTab"

export function UserProfile() {
    const { l10n } = useAppLocalization()

    const tabs = [
        {
            label: l10n.getString("profile-tab-profile"),
            component: (
                <QueryErrorBoundary>
                    <Suspense fallback={<LoadingSpinner />}>
                        <UserProfileContent />
                    </Suspense>
                </QueryErrorBoundary>
            ),
        },
        {
            label: l10n.getString("profile-tab-gdpr"),
            component: <GdprDownloadTab />,
        },
    ]

    return (
        <>
            <LocalizedStrict id="profile-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.USER_ACCOUNT}
                    title="User account"
                    icon={<FontAwesomeIcon icon={faInfoCircle} />}
                />
            </LocalizedStrict>
            <StandardTabs tabs={tabs} />
        </>
    )
}
